import React from "react";
import Tabs from 'material-ui/Tabs/Tabs';
import Tab from 'material-ui/Tabs/Tab';
import {WithDeleteDialogZzFlatButton, ZzFlatButton} from "core/components/buttons/buttons";
import PageAncestor from "core/common/page/pageAncestor";
import Toolmenu from "core/components/toolmenu/toolmenu";
import {ZzIconButtonRoute} from "core/components/buttons/icons";
import mdEntityService from "core/metamodel/mdEntityService";
import Grid from 'core/grid/domain/grid';
import {TabTemplate} from "core/common/config/mui-theme";
import {ErrorComp} from "core/components/errorComp/errorComp";
import {preSave, lovValue, IDomainObject} from "core/form/formUtils";
import gridService from "core/grid/gridService";
import GridComp from "core/grid/component/gridComp";
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import documentService from "core/document/documentService";
import DocumentTypeForm from "core/document/component/documentTypeForm";
import {tabStyle} from 'core/common/config/variables';
import Add from "material-ui/svg-icons/content/add";
import {MODULE, PERMISSION, SECURABLE_TYPE, PageProps} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import {DocumentType} from "core/document/documentDomain";
import {MovingBlocks, GridComposite, Movable} from "core/grid/gridUtils";
import uiService from "core/common/service/uiService";
import {action} from "mobx";
import {GridCompositeComp} from "core/grid/component/gridComp";
import {getSelectGridLocation, setSelectGridLocation} from "core/grid/gridSelectionSupport";
import {
  getSelectTenant, getSelectTenantGroup, setSelectTenant,
  setSelectTenantGroup
} from "core/tenant/tenantSelectionSupport";
import {loc} from "../common/config/locales";



const documentTemplateGridLocation = 'documentTemplateList';
const tenantGridComposite = 'tenantGridComposite';
const tenantGridLocation = 'tenantList';
const tenantGroupListLocation = 'tenantGroupList';
const gridLocationListLocation = 'gridLocationSelectionList';


@observer
export default class DocumentTypeDetail extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = 'Document Type';
  static icon = 'file-text';
  static protectedPage = true;


  static fetchData(routerParams, query) {
    console.log("DocumentTypeDetail#fetchData(%O)", query);

    let metadataPromise = mdEntityService.fetchEntityMetadata(['DocumentType']);

    let documentPromise: Promise<DocumentType>;

    if (routerParams.id === 'new') {
      documentPromise = Promise.resolve(new DocumentType({$new: true}));
    } else {
      documentPromise = documentService.readDocumentType(routerParams.id);
    }

    let gridPromise = gridService.fetchGrids(documentTemplateGridLocation, tenantGridLocation, tenantGroupListLocation, gridLocationListLocation);

    return Promise.all([metadataPromise, documentPromise, gridPromise])
      .then(([entityMap, documentTypeObject, gridLocationMap]: [any, DocumentType, any]) => {

        documentTypeObject.$movingBlocks = new MovingBlocks(tenantGridComposite, true, query.tab,
          new Grid(gridLocationMap.get(documentTemplateGridLocation), documentTypeObject.documentTypeId),
          new GridComposite(tenantGridComposite, 'Tenant selection', new Grid(gridLocationMap.get(tenantGridLocation)),
            new Grid(gridLocationMap.get(tenantGroupListLocation))),
          new Grid(gridLocationMap.get(gridLocationListLocation))
        );

        documentService.documentTypeObject = documentTypeObject.initAfterRead(false);
      });
  }



  componentWillMount() {
    uiService.addMediaQueryListener(this.mediaQueryListener);
  }


  /**
   * tohle je tady kvuli prechodu na jiny detail invoice (chained details)
   * @param prevProps
   */
  componentDidUpdate(prevProps) {
    if(this.idChanged(prevProps.params.id, this.props.params.id)) {
      documentService.documentTypeObject.$movingBlocks.searchExposedGrids(documentService.documentTypeObject);
    }
  }

  componentDidMount() {
    console.debug("%c componentDidMount", "background-color: magenta");
    documentService.documentTypeObject.$movingBlocks.searchExposedGrids(documentService.documentTypeObject);
  }

  componentWillUnmount() {
    uiService.removeMediaQueryListener(this.mediaQueryListener);
    documentService.documentTypeObject = null;
  }



  customValidate = (documentTypeObject) => {
    let errors = [];

    return errors;
  };


  findRootObject() {
    return documentService.documentTypeObject;
  }


  @action onSave = (evt) => {
    console.log('onSave ');
    uiService.showToolbarActionFlag();

    let result = preSave(documentService.documentTypeObject, this.customValidate);
    if (!result) {
      return;
    }

    documentService.saveDocumentType(documentService.documentTypeObject)
      .then( action("documentTypeSave-callback", (documentTypeJson: IDomainObject) => {
        let wasNew = documentService.documentTypeObject.cleanAfterSave(documentTypeJson);
        if (wasNew) {
          this.context.router.replaceWith('documentTypeDetail', {id: documentService.documentTypeObject.documentTypeId});
        }
        uiService.hideToolbarActionFlag();
      }), error => {
        documentService.documentTypeObject.$errors = error.getMessages();
      });

  };



  onAdd = (evt) => {
    console.log('onAdd');
    this.context.router.transitionTo("documentTypeDetail", {id: 'new'});
  };

  @action onDelete = (evt) => {
    console.log('onDelete');
    documentService.deleteDocumentType(documentService.documentTypeObject.documentTypeId)
      .then(response => {
        this.context.router.transitionTo('documentTypeList');
      }, error => {
        documentService.documentTypeObject.$errors = error.getMessages();
      });
  };


  render() {

    const {
      query
      } = this.props;

    const propsForCreateForm = {
      dataObject: documentService.documentTypeObject,
      rootObject: documentService.documentTypeObject,
      entity: mdEntityService.getEntity('DocumentType'),
      entities: mdEntityService.entityMap
    };

    console.debug('%c documentTypeDetail render query %O', 'background-color: yellow', this.props.query);


    let documentTypeQuery  = {
      documentTypeId: documentService.documentTypeObject.documentTypeId,
      documentTypeLabel: documentService.documentTypeObject.documentName,
      templateTypeId: lovValue(documentService.documentTypeObject.templateType)
    }

    const mainForm = (
      <form style={{marginTop: 10}}>
        <div className="row">
          <div className="col-xs-12">
            <DocumentTypeForm {...propsForCreateForm} />
          </div>
        </div>
      </form>
    );

    let movingBlocks = documentService.documentTypeObject.$movingBlocks;

    const gridCompArray = [
      <GridComp ref={documentTemplateGridLocation} grid={movingBlocks.getBlock(documentTemplateGridLocation) as Grid}
                uiLocation={movingBlocks.getUiLocation(documentTemplateGridLocation)}
                entities={mdEntityService.entityMap}>
        <ZzIconButtonRoute big routeName="documentTemplateDetail" params={{id: 'new'}} query={documentTypeQuery}
                           securable="documentTemplateDetail" permission={PERMISSION.New}>
          <Add/>
        </ZzIconButtonRoute>
      </GridComp>,

      <GridCompositeComp grid={movingBlocks.getBlock(tenantGridComposite) as GridComposite} uiLocation={movingBlocks.getUiLocation(tenantGridComposite)} >
        <div className="col-xs-12 col-sm-6" style={{padding: 10}}>
          <h4>Select Tenants</h4>
          <GridComp  grid={(movingBlocks.getBlock(tenantGridComposite) as GridComposite).groupMembers[0]} multiSelect={false} hideToolbar={true} gridClassName="detail-grid"
                    uiLocation={movingBlocks.getUiLocation(tenantGridComposite)}  functionMap={{getSelectTenant: getSelectTenant.bind(this, documentService.documentTypeObject), setSelectTenant: setSelectTenant.bind(this, documentService.documentTypeObject)}}
                    entities={mdEntityService.entityMap} />
        </div>
        <div className="col-xs-12 col-sm-6" style={{padding: 10}}>
          <h4>or select Tenant Groups</h4>
          <GridComp grid={(movingBlocks.getBlock(tenantGridComposite) as GridComposite).groupMembers[1]} multiSelect={false} hideToolbar={true} gridClassName="detail-grid"
                    uiLocation={movingBlocks.getUiLocation(tenantGridComposite)} functionMap={{getSelectTenantGroup: getSelectTenantGroup.bind(this, documentService.documentTypeObject), setSelectTenantGroup: setSelectTenantGroup.bind(this, documentService.documentTypeObject)}}
                    entities={mdEntityService.entityMap} />
        </div>
      </GridCompositeComp>,
      <GridComp grid={movingBlocks.getBlock(gridLocationListLocation) as Grid} multiSelect={false} uiLocation={movingBlocks.getUiLocation(gridLocationListLocation)}
                 functionMap={{getSelectGridLocation: getSelectGridLocation.bind(this, documentService.documentTypeObject), setSelectGridLocation: setSelectGridLocation.bind(this, documentService.documentTypeObject)}}
                entities={mdEntityService.entityMap} hideGridConfig hideRefresh />
    ];

    const standAloneGridComp = movingBlocks.pluckStandAloneBlock(gridCompArray);

    const tabArray = gridCompArray.map(gridComp => (
      <Tab label={gridComp.props.grid.label} style={tabStyle} onActive={this.activateTab.bind(this, gridComp.props.grid)} key={gridComp.props.grid.getBlockName()}  value={gridComp.props.grid.getBlockName()}>
        {gridComp}
      </Tab>
    ));


    const tabs = (tabArray.length) ? (
      <Tabs value={movingBlocks.activeBlockTab} className="detail-grid" tabTemplate={TabTemplate} inkBarStyle={{transition: 'inherit'}}
            contentContainerStyle={{width: '100%', flexGrow: 1, display: 'flex', minHeight: 0}} onChange={this.onTabChange}>
        {tabArray}
      </Tabs>
    ) : '';



    if (uiService.globalMediaQuery.matches) {
      return (
        <main className="main-content" style={{display: 'flex', flexDirection: 'row'}} >
          <div style={{display: 'flex', flexDirection: 'column', height: '100%', width:'50%'}}>
            {this._createToolMenu(documentService.documentTypeObject, query.gridLocation)}
            <ErrorComp messages={documentService.documentTypeObject.$errors} />
            <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
            <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>
            {mainForm}
            {tabs}
          </div>
          {standAloneGridComp}
        </main>
      );
    } else {
      return (
        <main className="main-content" style={{display: 'flex', flexDirection: 'column'}} >
          {this._createToolMenu(documentService.documentTypeObject, query.gridLocation)}
          <ErrorComp messages={documentService.documentTypeObject.$errors} />
          <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
          <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>
          {mainForm}
          {tabs}
        </main>
      );
    }
  }

  _createToolMenu(documentTypeObject, gridLocation) {
    return (
      <Toolmenu chainGridLocation={gridLocation} backAction={this.onBack} backDisabled={History.length <= 1} activeTab={documentTypeObject.$movingBlocks.activeBlockTab}>
        <ZzFlatButton onClick={this.onSave.bind(this, false)} disabled={!documentTypeObject.$dirty} label="Save"  permission={documentTypeObject.$new ? PERMISSION.New : PERMISSION.Update}/>
        <ZzFlatButton onClick={this.onAdd} disabled={documentTypeObject.$new} label="New" permission={PERMISSION.New}/>
        <WithDeleteDialogZzFlatButton entityName="DocumentType" pageAncestor={this} onClick={this.onDelete} disabled={documentTypeObject.$new} label="Delete" permission={PERMISSION.Delete}/>

      </Toolmenu>
    );
  }


}




// WEBPACK FOOTER //
// ./src/core/document/documentTypeDetail.tsx